import { Controller } from "@hotwired/stimulus"

/**
 * Room Planner Edit controller - mounts the React Room Planner in edit mode
 * Replaces the legacy @lazy_chunks[:rp_edit] mechanism
 */
export default class extends Controller {
  async connect() {
    // Dynamically import the room planner edit module
    // The module self-mounts to #room-planner element
    await import(/* webpackChunkName: "rpEdit" */ 'client/js/www/rp/rpEdit.index')
  }

  disconnect() {
    // React cleanup is handled internally by the module
  }
}

